(function() {
    'use strict';

    angular
        .module('consinfApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
